/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiDescribedFormGroup, EuiFieldPassword } from '@elastic/eui'

import { CuiFormComboBox, CuiFormField } from '@modules/cui/forms'
import { CuiTitleWithBadge } from '@modules/cui/TitleWithBadge'

import DocLink from '../../../../../../../components/DocLink'
import { labels, messages, sections } from '../../authProviderMessages'

import type { FunctionComponent } from 'react'

const options = [
  { value: 'AuthnRequest', label: 'AuthnRequest' },
  { value: 'LogoutRequest', label: 'LogoutRequest' },
  { value: 'LogoutResponse', label: 'LogoutResponse' },
]

const SigningConfiguration: FunctionComponent = () => (
  <EuiDescribedFormGroup
    title={
      <CuiTitleWithBadge>
        <FormattedMessage {...sections.signingConfiguration} />
      </CuiTitleWithBadge>
    }
    description={
      <FormattedMessage
        {...sections.signingConfigurationDescription}
        values={{
          learnMore: (
            <DocLink link='samlProviderSigningConfigurationDocLink'>
              <FormattedMessage {...messages.learnMore} />
            </DocLink>
          ),
        }}
      />
    }
  >
    <CuiFormField
      label={<FormattedMessage {...labels.signingCertificateUrl} />}
      name='signing_certificate_url'
      helpText={<FormattedMessage {...labels.signingCertificateUrlHelpText} />}
    />

    <CuiFormField
      label={<FormattedMessage {...labels.signingCertificateUrlPassword} />}
      name='signing_certificate_url_password'
      component={EuiFieldPassword}
      helpText={<FormattedMessage {...labels.signingCertificateUrlPasswordHelpText} />}
    />

    <CuiFormComboBox
      label={<FormattedMessage {...labels.signedSamlMessageTypes} />}
      name='signing_saml_messages'
      data-test-id='signing_saml_messages'
      helpText={<FormattedMessage {...labels.signedSamlMessageTypesHelpText} />}
      options={options}
    />
  </EuiDescribedFormGroup>
)

export default SigningConfiguration
